import { toast } from "react-toastify";
import { GET, POST } from "config/api.config";
import { COMMON, META } from "config/apiEndPoint";

/** GET `Meta/unmask/{maskedId}` — resolves the actual record id for table display. */
export const unmaskMaskedId = async (maskedId = "") => {
  const id = String(maskedId ?? "").trim();
  if (!id) return null;
  try {
    const response = await GET(META.UNMASK(id));
    return response;
  } catch (error) {
    return null;
  }
};

/** POST `common/link/shorten` — body `{ originalUrl }`. */
export const shortenCommonLink = async (originalUrl = "") => {
  const url = String(originalUrl ?? "").trim();
  if (!url) {
    toast.error("URL is required");
    return;
  }
  try {
    const response = await POST(COMMON.LINK_SHORTEN, { originalUrl: url });
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const extractUnmaskedIdFromResponse = (response) => {
  const data = response?.data ?? response;
  if (data == null || data === "") return "";
  if (typeof data === "string" || typeof data === "number") {
    return String(data).trim();
  }
  return String(
    data?.id ?? data?.actualId ?? data?.unmaskedId ?? data?.value ?? ""
  ).trim();
};
